module.exports = __webpack_public_path__ + "img/StreamAnomalyDetection.1071511c.png";